export const c_progress_stepper__fa_exclamation_triangle_MarginTop = {
  "name": "--pf-c-progress-stepper__fa-exclamation-triangle--MarginTop",
  "value": "-3px",
  "var": "var(--pf-c-progress-stepper__fa-exclamation-triangle--MarginTop)"
};
export default c_progress_stepper__fa_exclamation_triangle_MarginTop;